import React from 'react';
import { Label, Popup } from 'semantic-ui-react';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import stylesMobile from '../Components/styles/InventoryOverviewMobile.module.scss';
import { useTranslation } from 'react-i18next';

export enum LabelType {
  organicUnit,
  unNumber,
  casNumber,
  hazardStatement,
}

type Props = {
  labelType: LabelType;
  value: string | { statement: string; description: string };
  isMobile: boolean;
};

const SimplifiedInventoryLabel = ({ labelType, value = '', isMobile }: Props) => {
  const { t } = useTranslation();

  const renderLabel = (label: string, value: string) => {
    return (
      <div>
        {value !== '' && (
          <h4 className={styles.h4}>
            {label}:{' '}
            <Label className={isMobile ? stylesMobile.labelTextMobile : styles.labelText}>
              {value}
            </Label>
          </h4>
        )}
      </div>
    );
  };

  switch (labelType) {
    case LabelType.organicUnit:
      return renderLabel(
        t('inventory.details.page.contact.list.container.org.unit.input'),
        value as string
      );
    case LabelType.unNumber:
      return renderLabel(
        t('chemical.product.details.page.chemical.container.un.number.input.label'),
        value as string
      );
    case LabelType.casNumber:
      return renderLabel(
        t('chemical.product.details.page.chemical.container.cas.number.input.label'),
        value as string
      );
    case LabelType.hazardStatement:
      return (
        <div>
          {Array.isArray(value) && value.length > 0 && (
            <h4 className={styles.inlineElements}>
              {t(
                'chemical.product.details.page.chemical.inf.container.hazard.statements.input.label'
              )}
              :
            </h4>
          )}
          {Array.isArray(value) &&
            value.length > 0 &&
            value.map(({ statement, description }) => (
              <Popup
                key={description}
                trigger={
                  <Label key={statement} className={`${styles.inlineElements} ${styles.labelText}`}>
                    {statement}
                  </Label>
                }
                content={t(description)}
              />
            ))}
        </div>
      );
  }
};

SimplifiedInventoryLabel.defaultProps = {
  isMobile: false,
};

export default SimplifiedInventoryLabel;
